/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from "react";
import ReactDOM from "react-dom";
import {hideHeader} from "../constants/functions";
import {getJSON} from "../constants/network";
import routes from "../constants/routes";
import Vacio from "./Vacio";
import MenuTipoPoi from "./MenuTipoPoi";
import BreadCrumb from "./Breadcrumbs";
import BotonBonito from "./BotonBonito";
import PoiImagenes from "./PoiImagenes";
import Separador from "./Separador";
import Regiones from "./Regiones";
import {GOOGLE_MAPS_API_KEY} from '../constants/constants';
import {Modal} from 'react-bootstrap';

export default class extends Component{
    constructor() {
        super();
        this.state = {
            region: 'region-todas',
            imagenes: [],
            rutas: [],
            showModal: false
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.cambiarTipoPoi = this.cambiarTipoPoi.bind(this);
    }
    update(props) {
        let _this = this;
        getJSON(routes.estadoBy + "/" + props.match.params.estado)
            .then(result => {
                _this.setState({
                    region: result.data.region.slug,
                    estado: result.data
                })
            });
        getJSON(routes.estadoBy + "/" + props.match.params.estado + "/tipospoi?items=9999")
            .then(result => {
                _this.setState({
                    tipospoi: result.data
                })
            });
        getJSON(routes.estadoBy + "/" + props.match.params.estado + "/rutas?items=9999")
            .then(result => {
                _this.setState({
                    rutas: result.data
                })
            });
        getJSON(`${routes.estadoBy}/${props.match.params.estado}/imagenes`)
            .then(result => {
                _this.setState({
                    imagenes: result.data
                });
                _this.cargarImagenes(result.data);
            })
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            tipospoi: [],
            sectores: [],
            imagenes: []
        });
        this.cargarImagenes([]);
        this.update(nextProps);
    }
    componentDidMount() {
        hideHeader();
        this.update(this.props);
    }
    componentDidUpdate(){
        hideHeader();
    }
    cargarImagenes(imagenes) {
        let divImagenes = document.getElementById('imagenes-estado');
        if (imagenes && imagenes.length) {
            ReactDOM.render(<PoiImagenes imagenes={imagenes}/>, divImagenes);
        } else {
            ReactDOM.unmountComponentAtNode(divImagenes);
        }
    }
    openModal() {
        this.setState({
            showModal: true
        });
    }
    closeModal() {
        this.setState({
            showModal: false
        });
    }
    cambiarTipoPoi(event){
        this.props.history.push("/estado/" + this.props.match.params.estado + "/" + event.target.value);
    }
    render() {
        let _this = this;
        if (this.state && this.state.estado) {
            let estado = this.state.estado;

            let estadoGoogleMaps = `${estado.nombre} state,Venezuela`;
            if(estado.nombre === "Distrito Capital" || estado.nombre === "Guárico"){
                estadoGoogleMaps = `${estado.nombre}, Venezuela`;
            }

            let estadoImg = "";
            if (estado.imagen && estado.imagen.url) {
                estadoImg = estado.imagen.url;
            }

            let loQueHariaButton = "";
            let loQueHariaContent = "";
            if (estado.lo_que_haria) {
                loQueHariaButton = (
                    <div id="lo_que_haria_btn" className={this.state.region}>
                        <button type="button" onClick={this.openModal}>
                            Lo que yo haría
                        </button>
                    </div>
                );
                loQueHariaContent = (
                    <Modal bsSize="large"
                           className={"lo_que_haria_modal"}
                           show={this.state.showModal}
                           onHide={this.closeModal}>
                        <div>
                            <div className={`lo_que_haria ${_this.state.region}`}>
                                <img src="/img/brujula_oficial.png" id="logo" alt=""/>
                                <h3>
                                    Lo que yo haría
                                    <span className="close-icon fa fa-close pull-right" onClick={this.closeModal}/>
                                </h3>
                                <div className="contenido_wrapper">
                                    <div className="contenido"
                                         dangerouslySetInnerHTML={{__html: estado.lo_que_haria}}/>
                                </div>
                            </div>
                        </div>
                    </Modal>
                );
            }

            return (
                <div>
                    <div id="cambio-sector" className={`${this.state.region}`}>
                        <div className="contenedor-sector">
                            <BreadCrumb links={[{url: null, text: estado.nombre}]}/>
                        </div>
                    </div>
                    <div className="contenedor-menu-tipo-poi">
                        <div className="contenedor-sector" id="container_menu_tipo_poi">
                            <MenuTipoPoi tipos={this.state.tipospoi}
                                         baseUrl={`/estado/${estado.nombre}`}
                                         funcionCambiarTipoPoi={this.cambiarTipoPoi}
                                         inSearch={false}/>
                        </div>
                    </div>


                    <div className="contenedor-sector contenedor-estado">
                        <div className="row">
                            <div className="col-sm-12 col-xs-12" id="info_estado"
                                 style={{'backgroundImage': `url(${estadoImg})`}}>
                                <div className="row">
                                    <div className="col-sm-6 col-sm-offset-6 col-xs-12" id="descripcion_estado">
                                        <h2>{estado.nombre}</h2>
                                        <p dangerouslySetInnerHTML={{__html: estado.descripcion}}/>
                                        {loQueHariaButton}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <Separador texto={"Rutas"} region={this.state.region}/>
                        </div>

                        <div className="row">
                            <div className="col-xs-12 lista-rutas-estado">
                                {
                                    (() => {
                                        if (this.state.rutas && this.state.rutas.length) {
                                            return (
                                                <div className="row">
                                                    {
                                                        this.state.rutas.map(ruta => {
                                                            let imagen = '';
                                                            if (ruta.imagen) {
                                                                imagen = ruta.imagen.url;
                                                            }
                                                            return (
                                                                <div key={ruta.id} className="col-sm-6 col-xs-12">
                                                                    <BotonBonito
                                                                        texto={ruta.nombre}
                                                                        imagen={imagen}
                                                                        region={this.state.region}
                                                                        url={`/ruta/${ruta.slug}`}/>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        } else {
                                            return <Vacio/>
                                        }
                                    })()
                                }
                            </div>
                        </div>

                        <div className="row">
                            <Separador texto={"Puntos de Interés"} region={this.state.region}/>
                        </div>

                        <div className="row">
                            <div className="col-xs-12 lista-tipos-poi-estado ">
                                {
                                    (function () {
                                        if (_this.state.tipospoi) {
                                            return (
                                                <div className="row">
                                                    {
                                                        _this.state.tipospoi.map(tipopoi => {
                                                            return (
                                                                <div key={tipopoi.tipo.id}
                                                                     className={"col-sm-3 col-xs-12 " + estado.region.slug}>
                                                                    <BotonBonito
                                                                        icono={`/img/icono-${tipopoi.tipo.slug}.png`}
                                                                        url={`/estado/${_this.state.estado.nombre}/${tipopoi.tipo.slug}`}
                                                                        texto={tipopoi.tipo.nombre}
                                                                        imagen={`/img/fondo-${tipopoi.tipo.slug}.jpg`}
                                                                        region={_this.state.region}
                                                                    />
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            )
                                        }
                                        return <Vacio/>
                                    })()

                                }
                            </div>
                        </div>

                        <div className="row">
                            <Separador texto={"Mapa"} region={this.state.region}/>
                        </div>

                        <div className="row">
                            <div className="col-xs-12">
                                <div className={`estado_mapa ${_this.state.region}`}>
                                    <img src="/img/brujula_oficial.png" id="logo" alt=""/>
                                    <h3>Ubicación</h3>
                                    <div className="contenido">
                                        <div>
                                            <Vacio/>
                                        </div>
                                        <div>
                                            <iframe frameBorder="0" title="Google Map"
                                                    src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&q=${estadoGoogleMaps}`}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <Separador texto={"Galería"} region={this.state.region}/>
                        </div>
                        <div className="row">
                            <div className="poi-detalle" id="imagenes-estado"/>
                        </div>

                        {loQueHariaContent}

                    </div>
                    <div className="include-region">
                        <Regiones completo={false}/>
                    </div>
                </div>
            )
        }
        return <Vacio/>
    }
}



// WEBPACK FOOTER //
// ./src/components/EstadoInfo.js